export default (nudge: string) => /^apply:[0-9]+/.test(nudge);
